import axios from "axios";
import { API_BASE_URL } from "../config";
import { getAuthHeaders } from "./developerApi";

export const getBusinessStoreRatingSettings = async () => {
    const response = await axios.get(`${API_BASE_URL}/business-store-ratings/settings`, getAuthHeaders());
    return response.data;
};

export const updateBusinessStoreRatingSettings = async (payload) => {
    const response = await axios.put(`${API_BASE_URL}/business-store-ratings/settings`, payload, getAuthHeaders());
    return response.data;
};

export const importBusinessStoreRatings = async () => {
    const response = await axios.post(`${API_BASE_URL}/business-store-ratings/import`, {}, getAuthHeaders());
    return response.data;
};

export const getBusinessStoreRatingSummary = async () => {
    const response = await axios.get(`${API_BASE_URL}/business-store-ratings/summary`, getAuthHeaders());
    return response.data;
};

export const getBusinessStoreRatingRuns = async (limit = 20) => {
    const response = await axios.get(`${API_BASE_URL}/business-store-ratings/runs`, {
        ...getAuthHeaders(),
        params: { limit },
    });
    return response.data || [];
};

export const getBusinessStoreRatingCompetitors = async () => {
    const response = await axios.get(`${API_BASE_URL}/business-store-ratings/competitors`, getAuthHeaders());
    return response.data;
};

export const updateBusinessStoreRatingCompetitors = async (codes) => {
    const response = await axios.put(`${API_BASE_URL}/business-store-ratings/competitors`, { codes }, getAuthHeaders());
    return response.data;
};
